import { render, staticRenderFns } from "./warehouse-returns.vue?vue&type=template&id=7bea1f50&scoped=true"
import script from "./warehouse-returns.vue?vue&type=script&lang=js"
export * from "./warehouse-returns.vue?vue&type=script&lang=js"
import style0 from "./warehouse-returns.vue?vue&type=style&index=0&id=7bea1f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bea1f50",
  null
  
)

export default component.exports